export default __webpack_public_path__ + "static/media/list_active.14b501b2.svg";